import { DASHBOARD_LITE_MODELS_ACTION_TYPES, DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES } from '../../constants/actionTypes/dashboardLiteActionTypes';

export const fetchPartnerBrokerStart = () => ({
    type: DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_START
});

export const fetchPartnerBrokerSuccess = partnerBroker => ({
    type: DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_SUCCESS,
    payload: partnerBroker
});

export const fetchPartnerBrokerFail = error => ({
    type: DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_FAIL,
    payload: error
});

export const fetchDashboardModelsLiteStart = () => ({
    type: DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_START
});

export const fetchDashboardModelsLiteSuccess = partnerBroker => ({
    type: DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_SUCCESS,
    payload: partnerBroker
});

export const fetchDashboardModelsLiteFail = error => ({
    type: DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_FAIL,
    payload: error
});